export const ALERT_STATES: Record<string, string> = {
  OK: 'ok',
  WARNING: 'warning',
  CRITICAL: 'critical'
};

export const ALERT_MINIMUM_INTERVALS: Record<string, number> = {
  ok: 28800,
  warning: 28800,
  critical: 3600
}

